/** @jsx jsx */
import { FormError } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

interface ErrorTextProps {
  error: string;
}

export const ErrorText: FC<ErrorTextProps> = ({ error }) => {
  return <FormError text={error} />;
};
